import { AUTH } from '@dataTypes/authTypes';
import { grantUserListData } from '@dataTypes/grantAuthority';
import { convertUserType } from '@services/common/roleToKorean';
import React from 'react';
import { VscChromeClose } from 'react-icons/vsc';

interface MemberItemProps {
  loginId: string;
  name: string;
  phoneNumber: string;
  auth: AUTH;
  showDeleteUserModalWithClickedUser: (user: grantUserListData) => void;
  authority: AUTH | undefined;
}

const MemberItem = ({
  auth,
  loginId,
  name,
  phoneNumber,
  showDeleteUserModalWithClickedUser,
  authority,
}: MemberItemProps) => {
  const formattedPhoneNumber = () => {
    if (!phoneNumber) return '';
    return phoneNumber.slice(0, 7) + '****';
  };

  return (
    <div
      className={`item_wrapper ${authority === AUTH.MASTER || authority === AUTH.ADMIN ? 'master' : ''}`}
      onClick={() =>
        showDeleteUserModalWithClickedUser({
          login_id: loginId,
          name: name,
          phone_number: phoneNumber,
          authority: auth,
        })
      }
    >
      <div className="name">{name}</div>
      {(authority === AUTH.MASTER || authority === AUTH.ADMIN) && (
        <div className="loginId">{loginId}</div>
      )}
      <div className="phone">{formattedPhoneNumber()}</div>
      <div className="auth">{convertUserType(auth)}</div>
      <div className="close">
        <VscChromeClose />
      </div>
    </div>
  );
};

export default MemberItem;
